import { createContext, useContext, useMemo, type ReactNode } from 'react'
import { SlackClient } from '@assembly/slack'
import { usePlatform } from '../platform'
import type { Account } from '../state/accounts'

interface WorkspaceContextValue {
  account: Account
  client: SlackClient
}

const WorkspaceContext = createContext<WorkspaceContextValue | null>(null)

export function WorkspaceProvider({ account, children }: { account: Account; children: ReactNode }) {
  const platform = usePlatform()
  const client = useMemo(
    () => new SlackClient(account.token, platform.transport, platform.uploader),
    [account.token, platform],
  )
  return <WorkspaceContext.Provider value={{ account, client }}>{children}</WorkspaceContext.Provider>
}

export function useWorkspace(): WorkspaceContextValue {
  const ctx = useContext(WorkspaceContext)
  if (!ctx) throw new Error('useWorkspace must be used inside <WorkspaceProvider>')
  return ctx
}

export const useClient = () => useWorkspace().client
export const useMe = () => useWorkspace().account.userId
